import http from "api/https";

// Получить все входящие документы
export const getIncomingDocuments = (): Promise<any> => {
  return http.get("/IncomingDocument/GetAll");
};

// Получить входящие документы по ID approval_request
export const getIncomingDocumentsByApprovalRequest = (approval_request_id: number): Promise<any> => {
  return http.get(`/IncomingDocument/GetByApprovalRequestId?approvalRequestId=${approval_request_id}`);
};

// Получить один входящий документ по ID
export const getIncomingDocument = (id: number): Promise<any> => {
  return http.get(`/IncomingDocument/GetOneById?id=${id}`);
};

// Создать новый входящий документ
export const createIncomingDocument = (data: any): Promise<any> => {
  return http.post("/IncomingDocument/Create", data);
};

// Обновить входящий документ
export const updateIncomingDocument = (data: any): Promise<any> => {
  return http.put(`/IncomingDocument/Update`, data);
};

// Удалить входящий документ
export const deleteIncomingDocument = (id: number): Promise<any> => {
  return http.remove(`/IncomingDocument/Delete?id=${id}`,{});
};

// Получить пагинированные входящие документы
export const getIncomingDocumentsPaginated = (pageSize: number, pageNumber: number): Promise<any> => {
  return http.get(`/IncomingDocument/GetPaginated?pageSize=${pageSize}&pageNumber=${pageNumber}`);
};

// Следующие методы отсутствуют в контроллере, но оставлены для обратной совместимости
// При необходимости нужно добавить соответствующие эндпоинты в контроллер

// Получить входящие документы по типу документа
export const getIncomingDocumentsByType = (document_type_id: number): Promise<any> => {
  return http.get(`/IncomingDocument/by_document_type/${document_type_id}`);
};

// Получить входящий документ по BGA номеру
export const getIncomingDocumentByBgaNumber = (bga_document_number: string): Promise<any> => {
  return http.get(`/IncomingDocument/by_bga_number/${bga_document_number}`);
};

export const downloadFile = (id: number): Promise<any> => {
  return http.get(`/IncomingDocument/DownloadDocumentByID?id=${id}`, {}, );
};